<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline">
    <mat-label i18n>Timezone</mat-label>
    <input matInput [matAutocomplete]="timezone" id="booking-window-timezone" formControlName="timezone">
    <mat-autocomplete requireSelection #timezone="matAutocomplete">
      @for (option of filteredTzNames | async; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
